'use strict';

import { ajaxRequest } from '../common/ajax.js'

export var saveRaces = function (races, successCallbacks, errorCallbacks) {

  // Allow for the passing of a single race.
  if (races.constructor !== Array) {
    races = [races];
  }

  var post_data = {};
  post_data.races = races;
  post_data.caller_id = 'saveRaces';

  ajaxRequest({
    url: '/coach/save-sessions/',
    method: 'POST',
    data: post_data,
    success: successCallbacks,
    expected_response_type: 'json',
    error: errorCallbacks,
  });

}

export var fetchCalendarDataFromServer = function (athlete_id, start_date, end_date, successCallbacks, errorCallbacks) {

  const data = {
    athlete_id: athlete_id,
    start_date: start_date,
    end_date: end_date,
  }

  ajaxRequest({
    url: '/coach/fetch-calendar-data/',
    method: 'GET',
    data: data,
    success: successCallbacks,
    expected_response_type: 'json',
    error: errorCallbacks,
  });

}
